import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { EmployeeFormComponent } from './employee-form/employee-form.component';
import { DetailEmployeeComponent } from './detail-employee/detail-employee.component';
import { ListEmployeeComponent } from './list-employee/list-employee.component';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { EmployeeModalAjoutComponent } from './modal/employee-modal-ajout/employee-modal-ajout.component';
import { FilterEmployeeByNamePipe } from 'src/app/shared/pipes/filter-employee-by-name/filter-employee-by-name.pipe';

@NgModule({
	declarations: [
		EmployeeFormComponent,
		DetailEmployeeComponent,
		ListEmployeeComponent,
		EmployeeModalAjoutComponent
	],
	imports: [SharedModule, GestionDonneesModule],
	providers: [DateUtils, FilterEmployeeByNamePipe]
})
export class EmployeesModule {}
